import React, { FC, useState } from 'react';

import BeautyGuide from 'src/components/beautyGuide/BeautyGuide';
import { IChallengeResourceRender } from 'src/shared/models';
import { IBeautyGuideResource } from 'src/shared/models/beautyGuideResource.model';

interface OwnProps extends IChallengeResourceRender {
  config: IBeautyGuideResource;
}

const ContestBeautyGuide: FC<OwnProps> = ({
  config,
  updateChallenge,
  updateUserPoints,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <BeautyGuide
      {...{
        config,
        setShowModal,
        showModal,
        updateChallenge,
        updateUserPoints,
      }}
    />
  );
};

export default ContestBeautyGuide;
